import { createTheme, Theme } from "@mui/material/styles";

export type Mode = "light" | "dark";

// App-wide MUI theme. Portaled surfaces (DatePicker popovers, Select menus,
// profile Menu, notifications) can only be themed here — never via page tokens.
export const buildAppTheme = (mode: Mode): Theme =>
  createTheme({
    palette:
      mode === "light"
        ? {
            mode: "light",
            primary: { main: "#1f93ff" },
            secondary: { main: "#f50057" },
            background: { default: "#f5f5f5", paper: "#ffffff" },
          }
        : {
            mode: "dark",
            primary: { main: "#4da3ff" },
            secondary: { main: "#f50057" },
            background: { default: "#0a1120", paper: "#111a2c" },
            divider: "rgba(255,255,255,0.08)",
            text: {
              primary: "#e8eef9",
              secondary: "rgba(232,238,249,0.72)",
            },
          },
    components: {
      MuiPaper: {
        // Kill MUI's dark-mode elevation overlay tint so popovers match cards
        styleOverrides: { root: { backgroundImage: "none" } },
      },
    },
  });
